import { css } from 'styled-components';

const sizes = {
  phone: 767,
  smallPhone: 375,
  large: 768,
  desktop: 991,
  wide: 1199,
};

export const media = Object.keys(sizes).reduce((accumulator, label) => {
  const emSize = sizes[label] / 16;
  accumulator[label] = (...args) => css`
    @media (max-width: ${emSize}em) {
      ${css(...args)};
    }
  `;
  return accumulator;
}, {});
